import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  projSettlePaymentList: [],
  projSettlePaymentInfo: {
    paymentId: '',
    paymentName: '',
    paymentDesc: '',
    compId: '',
    projId: '',
    ctrAcctId: '',
    type: '',
    seq: 0,
    status: '',
    crtBy: '',
    crtOn: new Date(0),
    updBy: '',
    updOn: new Date(0),
    //
    indUsed: ''
  },
  editIndex: -1,
  editAction: '',
  projSettlePaymentDDList: [],
  END_STATE: null
}

const getters = {

}

const actions = {
  async insertProjSettlePayment({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    // debugger
    const insertObj = await postReq(END_POINTS.INSERT_RSP_PROJ_SETTLE_PAYMENT, {
      data: {
        // paymentId: state.projSettlePaymentInfo.paymentId,
        paymentName: state.projSettlePaymentInfo.paymentName,
        paymentDesc: state.projSettlePaymentInfo.paymentDesc,
        ctrAcctId: state.projSettlePaymentInfo.ctrAcctId,
        type: state.projSettlePaymentInfo.type,
        status: state.projSettlePaymentInfo.status,
        //
        projId: projId,
        compId: compId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return insertObj
  },
  async updateProjSettlePayment({
    dispatch,
    commit,
    state
  }, {paymentId, projId, compId, codeParam}) {
    let projSettlePaymentInfo = {
      paymentName: state.projSettlePaymentInfo.paymentName,
      paymentDesc: state.projSettlePaymentInfo.paymentDesc,
      ctrAcctId: state.projSettlePaymentInfo.ctrAcctId,
      type: state.projSettlePaymentInfo.type,
      status: state.projSettlePaymentInfo.status,
      //
      key: {
        paymentId: paymentId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_SETTLE_PAYMENT, {
      data: projSettlePaymentInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async removeProjSettlePayment({
    commit,
    state
  }, {paymentId, projId, compId, codeParam}) {
    const deleteObject = await deleteSendReq(END_POINTS.REMOVE_RSP_PROJ_SETTLE_PAYMENT + `?paymentId=${paymentId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return deleteObject
  },
  async findProjSettlePaymentList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_RSP_PROJ_SETTLE_PAYMENT_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjSettlePaymentList', response)
  },
  async findProjSettlePaymentDDList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_RSP_PROJ_SETTLE_PAYMENT_DD_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjSettlePaymentDDList', response)
  },
  END_ACTIONS() {}
}

const mutations = {
  updatePaymentId(state, value) {
    state.projSettlePaymentInfo.paymentId = value
  },
  updatePaymentName(state, value) {
    state.projSettlePaymentInfo.paymentName = value
  },
  updatePaymentDesc(state, value) {
    state.projSettlePaymentInfo.paymentDesc = value
  },
  updateCompId(state, value) {
    state.projSettlePaymentInfo.compId = value
  },
  updateProjId(state, value) {
    state.projSettlePaymentInfo.projId = value
  },
  updateCtrAcctId(state, value) {
    state.projSettlePaymentInfo.ctrAcctId = value
  },
  updateType(state, value) {
    state.projSettlePaymentInfo.type = value
  },
  updateSeq(state, value) {
    state.projSettlePaymentInfo.seq = value
  },
  updateStatus(state, value) {
    state.projSettlePaymentInfo.status = value
  },
  updateProjSettlePaymentList(state, response) {
    if (response.success === true && response.data.length) {
      state.projSettlePaymentList = response.data
    } else {
      state.projSettlePaymentList = []
    }
  },
  updateProjSettlePaymentDDList(state, response) {
    if (response.success === true && response.data.length) {
      state.projSettlePaymentDDList = Utils.toListWapper(response.data, {valueField: 'paymentId', descrField: 'paymentName'})
    } else {
      state.projSettlePaymentDDList = []
    }
  },
  updateProjSettlePaymentListEmpty(state) {
    state.editIndex = -1
    state.projSettlePaymentList = []
  },
  updateProjSettlePaymentEmpty(state) {
    state.projSettlePaymentInfo.paymentId = ''
    state.projSettlePaymentInfo.paymentName = ''
    state.projSettlePaymentInfo.paymentDesc = ''
    state.projSettlePaymentInfo.compId = ''
    state.projSettlePaymentInfo.projId = ''
    state.projSettlePaymentInfo.ctrAcctId = ''
    state.projSettlePaymentInfo.type = ''
    state.projSettlePaymentInfo.seq = 0
    state.projSettlePaymentInfo.status = ''
    state.projSettlePaymentInfo.crtBy = ''
    state.projSettlePaymentInfo.crtOn = new Date(0)
    state.projSettlePaymentInfo.updBy = ''
    state.projSettlePaymentInfo.updOn = new Date(0)

    state.projSettlePaymentInfo.indUsed = ''
  },
  updateProjSettlePaymentInfo(state, projSettlePaymentInfo) {
    // debugger
    state.projSettlePaymentInfo.paymentId = projSettlePaymentInfo.paymentId
    state.projSettlePaymentInfo.paymentName = projSettlePaymentInfo.paymentName
    state.projSettlePaymentInfo.paymentDesc = projSettlePaymentInfo.paymentDesc
    state.projSettlePaymentInfo.compId = projSettlePaymentInfo.compId
    state.projSettlePaymentInfo.projId = projSettlePaymentInfo.projId
    state.projSettlePaymentInfo.ctrAcctId = projSettlePaymentInfo.ctrAcctId
    state.projSettlePaymentInfo.type = projSettlePaymentInfo.type
    state.projSettlePaymentInfo.seq = projSettlePaymentInfo.seq
    state.projSettlePaymentInfo.status = projSettlePaymentInfo.status
    state.projSettlePaymentInfo.crtBy = projSettlePaymentInfo.crtBy
    state.projSettlePaymentInfo.crtOn = projSettlePaymentInfo.crtOn
    state.projSettlePaymentInfo.updBy = projSettlePaymentInfo.updBy
    state.projSettlePaymentInfo.updOn = projSettlePaymentInfo.updOn
    //
    state.projSettlePaymentInfo.indUsed = projSettlePaymentInfo.indUsed
  },
  updateEditIndex(state, value) {
    state.editIndex = value
  },
  updateEditAction(state, value) {
    state.editAction = value
  },
  // newEmptyRowObj() {
  //   return {
  //     ctrAcctId: '',
  //     type: '',
  //     indUsed: '',
  //     status: ''
  //   }
  // },
  appendBottomRow() {
    this.commit('confProjSettlePaymentManage/updateProjSettlePaymentEmpty')
    let obj = {...state.projSettlePaymentInfo}
    // debugger
    obj.isBottomRow = true
    state.projSettlePaymentList.push(obj)
  },
  handleAdd(state, {row, index, ctrAcctId, type, status}) {
    // debugger
    this.commit('confProjSettlePaymentManage/updateProjSettlePaymentEmpty')
    this.commit('confProjSettlePaymentManage/updateEditIndex', index)
    this.commit('confProjSettlePaymentManage/updateEditAction', 'insert')
    //
    this.commit('confProjSettlePaymentManage/updateCtrAcctId', ctrAcctId)
    this.commit('confProjSettlePaymentManage/updateType', type)
    this.commit('confProjSettlePaymentManage/updateStatus', status)
  },
  handleEdit(state, {row, index}) {
    // debugger
    this.commit('confProjSettlePaymentManage/updateProjSettlePaymentInfo', row)
    this.commit('confProjSettlePaymentManage/updateEditIndex', index)
    this.commit('confProjSettlePaymentManage/updateEditAction', 'update')
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/confProjSettlePaymentManage.js